<div class="bg-transparent pos-absolute" [ngStyle]="_blockStyle">
  <canvas
    #signCanvas
    class="sign-canvas-style"
    [ngStyle]="_canvasStyle"
  ></canvas>
  <div
    class="row-layout flex-content-end"
    [ngClass]="_cleanBtnStyle"
  >
    <button (click)="clearClick()">Leeren</button>
  </div>
</div>
